export default __webpack_public_path__ + "static/pop_au_image-819061654e8605542da165131abc2bbc.png";